import { Injectable } from '@angular/core';

/*
  Generated class for the GlobalProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GlobalProvider {
  private win: any;

  constructor() {

  }



}



// WEBPACK FOOTER //
// ./src/providers/global/global.ts